
<div
  class="w-full flex flex-row justify-center container-options-main-container font-rubik"
>
  <div class="w-full max-w-1024 mx-5">
    <div class="container-options-main-text">
      <p class="text-white">
        Container Alliance is the shipping container company to choose when
        you need solutions for your storage and shipping needs. No other
        container provider offers you as much as we do, from refrigerated
        units for cold storage to converted containers for use as temporary
        office space. We serve customers throughout California and Nevada,
        helping them find shipping containers for sale or rent that meet their
        requirements. As a full-service cargo container company, we also
        provide customization options as well as accessories to ensure you
        have exactly what you need.
      </p>
    </div>
    <div class="flex flex-col gap-3">
      <div class="w-full flex flex-col lg:flex-row gap-3">
        <div
          @mouseenter="hovered = 'container-sales'"
          @mouseleave="hovered = ''"
          @click="cardClick('sale')"
          class="w-full h-auto card flex flex-col justify-between cursor-pointer"
        >
          <button class="text-left pl-5 pr-5 pt-5">
            <h1 class="font-bold mb-2 text-lg">Container Sales</h1>
            <p class="font-sm font-rubik">
              {{ descriptionDisplay('container-sales') }}
            </p>
          </button>
          <div
            class="container-option-card-image"
            :style="{ backgroundImage: `url(${images[0]})` }"
          ></div>
        </div>
        <div class="w-full h-auto flex flex-col gap-3">
          <div
            @mouseenter="hovered = 'refrigerated-containers'"
            @mouseleave="hovered = ''"
            class="w-full h-1/2 card"
          >
            <button @click="cardClick('refrigerate')" class="text-left p-5">
              <h1 class="font-bold mb-2 text-lg">Refrigerated Containers</h1>
              <p class="font-sm font-rubik">
                {{ descriptionDisplay('refrigerated-containers') }}
              </p>
            </button>
          </div>
          <div
            @mouseenter="hovered = 'portable-offices'"
            @mouseleave="hovered = ''"
            class="w-full h-1/2 card"
          >
            <button @click="cardClick('office')" class="text-left p-5">
              <h1 class="font-bold mb-2 text-lg">Portable Offices</h1>
              <p class="font-sm font-rubik">
                {{ descriptionDisplay('portable-offices') }}
              </p>
            </button>
          </div>
        </div>
      </div>
      <div class="w-full flex flex-col lg:flex-row gap-3">
        <div class="w-full h-auto flex flex-col gap-3">
          <div
            @mouseenter="hovered = 'container-modifications'"
            @mouseleave="hovered = ''"
            class="w-full h-1/2 card"
          >
            <button @click="cardClick('modification')" class="text-left p-5">
              <h1 class="font-bold mb-2 text-lg">Container Modifications</h1>
              <p class="font-sm font-rubik">
                {{ descriptionDisplay('container-modifications') }}
              </p>
            </button>
          </div>
          <div
            @mouseenter="hovered = 'accessories'"
            @mouseleave="hovered = ''"
            class="w-full h-1/2 card"
          >
            <button
              @click="routingMethod('/solutions/accessories')"
              class="text-left p-5"
            >
              <h1 class="font-bold mb-2 text-lg">
                Container Alliance Accessories
              </h1>
              <p class="font-sm font-rubik">
                {{ descriptionDisplay('accessories') }}
              </p>
            </button>
          </div>
        </div>
        <div
          @mouseenter="hovered = 'container-rentals'"
          @mouseleave="hovered = ''"
          @click="cardClick('rental')"
          class="w-full h-auto card flex flex-col justify-between cursor-pointer"
        >
          <button class="text-left p-5">
            <h1 class="font-bold mb-2 text-lg">Container Rentals</h1>
            <p class="font-sm font-rubik">
              {{ descriptionDisplay('container-rentals') }}
            </p>
          </button>
          <div
            class="container-option-card-image"
            :style="{ backgroundImage: `url(${images[1]})` }"
          ></div>
        </div>
      </div>
      <zipcodeModal
        v-if="modalOpen"
        @close="modalOpen = false"
        :solutionSlug="solutionSlug"
      />
    </div>
  </div>
</div>
